// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__U7ZBy","visible":"Overlay_visible__Y0t7g"};